export const DEFAULT_LOCATION = 'usa-ca-004';

export const DEFAULT_SKU = 300;

export const SLOTS_QUERY_DAYS = 31;

export const RESEARCH_ONLY_LOCATION = 'usa-ma-001';

// SKU 370 Supporting Constants
export const SKU_370_ENABLED_LOCATIONS = [
  { locationId: 'usa-ca-004', fistAvailableBookingDate: '2025-03-17' },
  { locationId: 'usa-ny-001', fistAvailableBookingDate: '2025-03-17' },
  { locationId: 'usa-ca-001', fistAvailableBookingDate: '2025-03-17' },

  { locationId: 'usa-fl-001', fistAvailableBookingDate: '2025-04-22' },
  { locationId: 'usa-md-001', fistAvailableBookingDate: '2025-04-22' },
  { locationId: 'usa-tx-001', fistAvailableBookingDate: '2025-04-22' },
];

export const WHOLE_BODY_ENHANCED_SCREENING_SKU_ID = 370;

export const SKU_300_ALTERNATE_SUBTITLE =
  'A comprehensive imaging-based health assessment that scans the head, neck, chest, abdomen, pelvis, and legs for cancer, aneurysms and disease.';

export const SKU_300_ALTERNATE_DESCRIPTION = `Detection of tumors as small as 1cm, including prostate, cervical, uterine, and ovarian cancers in the pelvis. Evaluates hundreds of other conditions including brain aneurysms, small vessel ischemia (stroke risk factor), previous strokes, multiple sclerosis, sinus issues, fatty liver disease, disc herniation, spinal cord abnormalities, and spinal degeneration. Ankles may not be visible for people taller than 5'9" or 175cm. Arms and feet are not included.`;

export const SKU_370_INFO_HYPERLINK = 'https://prenuvo.com/enhanced-screening';

export const SKUS = {
  WHOLE_BODY: '300',
  HEAD_AND_TORSO: '200',
  TORSO: '100',
  WHOLE_BODY_ENHANCED_SCREENING: '370',
};

export const SKUS_MAP = {
  [SKUS.WHOLE_BODY]: 'Whole Body',
  [SKUS.HEAD_AND_TORSO]: 'Head & Torso',
  [SKUS.TORSO]: 'Torso',
  [SKUS.WHOLE_BODY_ENHANCED_SCREENING]: 'Enhanced Screening',
};

export const SESSION_EXPIRED_ERROR = {
  title: 'Your booking has expired',
  message: 'Please start again',
};

export const MEMBER_MAX_AGE = new Date().getFullYear() - 1899;
export const MEMBER_MIN_AGE = 18;

export const SKU_OPTIONS = [
  {
    id: +SKUS.WHOLE_BODY_ENHANCED_SCREENING,
    label: SKUS_MAP[SKUS.WHOLE_BODY_ENHANCED_SCREENING],
  },
  {
    id: +SKUS.WHOLE_BODY,
    label: SKUS_MAP[SKUS.WHOLE_BODY],
  },
  {
    id: +SKUS.HEAD_AND_TORSO,
    label: SKUS_MAP[SKUS.HEAD_AND_TORSO],
  },
  {
    id: +SKUS.TORSO,
    label: SKUS_MAP[SKUS.TORSO],
  },
];

export const REFERRAL_CREDIT_ENABLED_SKUS = ['300', '370'];
export const MARKETING_REFERRAL_ENABLED_SKUS = ['300', '370'];

export const ISAUSTRALIANLOCATION = (locationId: string) => locationId.startsWith('aus-');

export const ISNALOCATION = (locationId: string) =>
  locationId.startsWith('usa-') || locationId.startsWith('can-');
